export const amountUnitsOptions = [
  {
    label: '$',
    value: 'dollars',
  },
  {
    label: '%',
    value: 'percent',
  },
];

export const minimumUnitsOptions = [
  {
    label: 'No Minimum',
    value: '',
  },
  {
    label: '$',
    value: 'dollars',
  },
  {
    label: 'Copies',
    value: 'copies',
  },
];

export const durationOptions = [
  {
    label: 'Once',
    value: 'once',
  },
  {
    label: 'Forever',
    value: 'forever',
  },
];

export const copyLimitScopeOptions = [
  {
    label: 'Item (each eligible item)',
    value: 'item',
  },
  {
    label: 'Order (whole order total)',
    value: 'order',
  },
];

export const submitButtonTextOptions = {
  edit: 'Edit Discount',
  create: 'Create Discount',
};
